import { debugLogReducer } from "../helpers/debugHelper";
import { types } from "../types/types";

const initialState = {

  listFullCatalogCiius: [],
  listCatalogCiiusLevel1: [],
  listCatalogCiiusLevel2: [],
  listCatalogCiiusLevel3: [],
  listCatalogCiiusLevel4: [],
  listCatalogCiiusLevel5: [],
  listCatalogCiiusLevel6: [],
  objectCatalogCiiuLevel1Selected: {},
  objectCatalogCiiuLevel2Selected: {},
  objectCatalogCiiuLevel3Selected: {},
  objectCatalogCiiuLevel4Selected: {},
  objectCatalogCiiuLevel5Selected: {},
  objectCatalogCiiuLevel6Selected: {},

  catalogciius_idLevel1: [],
  catalogciiu_levelsSelected: {},

  catalogCiiuAllLevel6: [],

  catalogCiiu: {},
  catalogCiius: [],
  catalogCiiusP: [],
  catalogCiiusS: [],

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",
  
  listFullCatalogCiiusNoLevel6: []
};
export const catalogCiiuReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CATALOGCIIU_START_LOADING:
      return {
        ...state,
        catalogCiius: action.payload,
      };

    case types.CATALOGCIIU_START_LOADING_LEVEL1:
      return {
        ...state,
        listCatalogCiiusLevel1: action.payload,
      };

    case types.CATALOGCIIU_SELECT_LEVEL1:
      return {
        ...state,
        objectCatalogCiiuLevel1Selected: action.payload,
      };

    case types.CATALOGCIIU_START_LOADING_LEVEL2:
      return {
        ...state,
        listCatalogCiiusLevel2: action.payload,
      };

    case types.CATALOGCIIU_SELECT_LEVEL2:
      return {
        ...state,
        objectCatalogCiiuLevel2Selected: action.payload,
      };

    case types.CATALOGCIIU_START_LOADING_LEVEL3:
      return {
        ...state,
        listCatalogCiiusLevel3: action.payload,
      };

    case types.CATALOGCIIU_SELECT_LEVEL3:
      return {
        ...state,
        objectCatalogCiiuLevel3Selected: action.payload,
      };

    case types.CATALOGCIIU_START_LOADING_LEVEL4:
      return {
        ...state,
        listCatalogCiiusLevel4: action.payload,
      };

    case types.CATALOGCIIU_SELECT_LEVEL4:
      return {
        ...state,
        objectCatalogCiiuLevel4Selected: action.payload,
      };

    case types.CATALOGCIIU_START_LOADING_LEVEL5:
      return {
        ...state,
        listCatalogCiiusLevel5: action.payload,
      };

    case types.CATALOGCIIU_SELECT_LEVEL5:
      return {
        ...state,
        objectCatalogCiiuLevel5Selected: action.payload,
      };

    case types.CATALOGCIIU_START_LOADING_LEVEL6:
      return {
        ...state,
        listCatalogCiiusLevel6: action.payload,
      };

    case types.CATALOGCIIU_SELECT_LEVEL6:
      return {
        ...state,
        objectCatalogCiiuLevel6Selected: action.payload,
      };

    case types.CATALOGCIIU_CLEAN_LEVEL1:
      return {
        ...state,
        objectCatalogCiiuLevel2Selected: {},
        listCatalogCiiusLevel2: [],
        objectCatalogCiiuLevel3Selected: {},
        listCatalogCiiusLevel3: [],
        objectCatalogCiiuLevel4Selected: {},
        listCatalogCiiusLevel4: [],
        objectCatalogCiiuLevel5Selected: {},
        listCatalogCiiusLevel5: [],
        objectCatalogCiiuLevel6Selected: {},
        listCatalogCiiusLevel6: [],
      };

    case types.CATALOGCIIU_CLEAN_LEVEL2:
      return {
        ...state,
        objectCatalogCiiuLevel3Selected: {},
        listCatalogCiiusLevel3: [],
        objectCatalogCiiuLevel4Selected: {},
        listCatalogCiiusLevel4: [],
        objectCatalogCiiuLevel5Selected: {},
        listCatalogCiiusLevel5: [],
        objectCatalogCiiuLevel6Selected: {},
        listCatalogCiiusLevel6: [],
      };

    case types.CATALOGCIIU_CLEAN_LEVEL3:
      return {
        ...state,
        objectCatalogCiiuLevel4Selected: {},
        listCatalogCiiusLevel4: [],
        objectCatalogCiiuLevel5Selected: {},
        listCatalogCiiusLevel5: [],
        objectCatalogCiiuLevel6Selected: {},
        listCatalogCiiusLevel6: [],
      };

    case types.CATALOGCIIU_CLEAN_LEVEL4:
      return {
        ...state,
        objectCatalogCiiuLevel5Selected: {},
        listCatalogCiiusLevel5: [],
        objectCatalogCiiuLevel6Selected: {},
        listCatalogCiiusLevel6: [],
      };

    case types.CATALOGCIIU_CLEAN_LEVEL5:
      return {
        ...state,
        objectCatalogCiiuLevel6Selected: {},
        listCatalogCiiusLevel6: [],
      };

    /* Esto no esta todavia */
    case types.CATALOGCIIU_UPDATE:
      if (state.catalogCiiusS.length > 0) {
        return {
          ...state,
          catalogCiiusS: state.catalogCiiusS.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
          catalogCiiusP: state.catalogCiiusP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      } else {
        return {
          ...state,
          catalogCiiusP: state.catalogCiiusP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      }

    case types.CATALOGCIIU_DELETE:
      if (state.catalogCiiusS.length > 0) {
        return {
          ...state,
          catalogCiiusS: state.catalogCiiusS.filter((usr) => usr.id !== action.payload),
          catalogCiiusP: state.catalogCiiusP.filter((usr) => usr.id !== action.payload),
          catalogCiiu: {},
        };
      } else {
        return {
          ...state,
          catalogCiiusP: state.catalogCiiusP.filter((usr) => usr.id !== action.payload),
          catalogCiiu: {},
        };
      }

    case types.CATALOGCIIU_START_LOADING_PAGINATED:
      return {
        ...state,
        catalogCiiusP: action.payload.catalogCiiusP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.CATALOGCIIU_START_SEARCH:
      return {
        ...state,
        catalogCiiusS: action.payload,
      };

    case types.CATALOGCIIU_START_SEARCH_PAGINATED:
      return {
        ...state,
        catalogCiiusP: action.payload.catalogCiiusP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.CATALOG_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        catalogCiiusS: [],
      };

      /*Add */
    case types.CATALOGCIIU_SELECT:
      return {
        ...state,
        catalogCiiu: action.payload,
      };

    case types.CATALOGCIIU_CLEAN:
      return {
        ...state,
        catalogCiiu: {},
      };

    case types.CATALOGCIIU_START_REGISTER:
      return {
        ...state,
        catalogCiiu: action.payload,
      };

    case types.CATALOGCIIU_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    case types.CATALOGCIIU_START_LOADING_ALL_LEVEL6:
      return {
        ...state,
        catalogCiiuAllLevel6: action.payload,
      };

    case types.CATALOGCIIU_START_LOADING_ALL:
      return {
        ...state,
        listFullCatalogCiius: action.payload,
      };

      case types.CATALOGCIIU_START_LOADING_NO_LEVEL6:
      return {
        ...state,
        listFullCatalogCiiusNoLevel6: action.payload,
      };

    case types.CATALOGCIIU_START_LOADING_FILTER:

      if (action.payload == null || typeof action.payload !== 'object') {
        return state;
      }

      const { catalogciiu_level2_codes} = action.payload;
      const catalogCiiuIdsListL2 = catalogciiu_level2_codes && catalogciiu_level2_codes.split(",");

      return {
        ...state,

        listCiiusFilter: getFilterCatalogL2(state.listCatalogCiiusLevel2, catalogCiiuIdsListL2),


      };

    default:
      return state;
  }
};

const getFilterCatalogL2 = (arrayFull, uniqueArray) => {

  debugLogReducer(":: catalogCiiuReducer - getFilterCatalogL2, arrayFull, uniqueArray", arrayFull, uniqueArray);
  
  let listFilterCatalog = [];

  if (uniqueArray) {

    for (const idUniqueFound of uniqueArray) {
      
      for (const elemSearch of arrayFull) {
        
        const codeSecondLevel = elemSearch.code && elemSearch.code.substring(0, 3);
        if (idUniqueFound === codeSecondLevel) {
          
          elemSearch.isChecked = false;
          listFilterCatalog.push(elemSearch);
        }
      }
    }
  }

  listFilterCatalog.sort((a, b) => a.id - b.id)

  return listFilterCatalog;
}